import Vue from "vue";
import App from "./App";
import router from "./router";
import Vant from "vant";
import "vant/lib/index.less";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import { Notify } from "vant";
import { Lazyload } from "vant";
import Cookies from "js-cookie";
Vue.config.productionTip = false;
import "./iconfont/iconfont.css";
import "./index.css";
import "./rem.js";
import { apiPost } from "@/api/api";
import wxUtils from "@/utils/wxUtils";
import VideoPlayer from "vue-video-player";
import { setLocal } from "@/utils/com";
import EtmsBackTop from "@/components/common/EtmsBackTop";
import etmsConfig from "@/api/etmsConfig";

import VueTouch from "vue-touch";
Vue.use(VueTouch, { name: "v-touch" });

Vue.prototype.etmsConfig = etmsConfig;

require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
import AvatarImg from "@/components/common/AvatarImg";
Vue.component("AvatarImg", AvatarImg);
Vue.use(VideoPlayer);
Vue.use(Vant);
Vue.use(ElementUI);
Vue.use(Cookies);
Vue.use(Notify);
Vue.use(Lazyload);
Vue.component("EtmsBackTop", EtmsBackTop);
Vue.config.productionTip = false;

import img from "@/api/img";
import imgdd from "@/ddzj/img";

if (APP_MD == "dd") {
  Vue.prototype.etmsimg = imgdd;
} else {
  Vue.prototype.etmsimg = img;
}

// Vant.Image.props.lazyLoad.default = true;
Vue.directive("input-limit", {
  bind(el, binding) {
    var wins_0 = /[^\d]/g; //整数判断
    var wins_1 = /[^\d^\.]/g; //小数判断
    var flag = true;
    var points = 0;
    var lengths = 0;
    var remainder = 0;
    var no_int = 0;
    const target =
      el instanceof HTMLInputElement ? el : el.querySelector("input");
    target.addEventListener("compositionstart", e => {
      flag = false;
    });
    target.addEventListener("compositionend", e => {
      flag = true;
    });
    target.addEventListener("input", e => {
      setTimeout(function() {
        if (flag) {
          if (binding.value == 0) {
            if (wins_0.test(e.target.value)) {
              e.target.value = e.target.value.replace(wins_0, "");
              e.target.dispatchEvent(new Event("input")); //手动更新v-model值
            }
          }
          if (binding.value == 1) {
            if (
              wins_0.test(e.target.value.toString().replace(/\d+\.(\d*)/, "$1"))
            ) {
              remainder = true;
            }
            if (e.target.value.split(".").length - 1 > 1) {
              points = true;
            }
            if (e.target.value.toString().split(".")[1] != undefined) {
              if (e.target.value.toString().split(".")[1].length > 1) {
                lengths = true;
              }
            }
            if (e.target.value.toString().indexOf(".") != -1) {
              no_int = false;
            } else {
              no_int = true;
            }
            if (wins_1.test(e.target.value) || lengths || points || remainder) {
              if (!no_int) {
                e.target.value = e.target.value
                  .replace(wins_1, "")
                  .replace(".", "$#$")
                  .replace(/\./g, "")
                  .replace("$#$", ".")
                  .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3")
                  .substring(0, e.target.value.indexOf(".") + 2);
              } else {
                e.target.value = e.target.value.replace(wins_0, "");
              }
              e.target.dispatchEvent(new Event("input"));
            }
          }
          if (binding.value == 2) {
            if (
              wins_0.test(e.target.value.toString().replace(/\d+\.(\d*)/, "$1"))
            ) {
              remainder = true;
            }
            if (e.target.value.split(".").length - 1 > 1) {
              points = true;
            }
            if (e.target.value.toString().split(".")[1] != undefined) {
              if (e.target.value.toString().split(".")[1].length > 2) {
                lengths = true;
              }
            }
            if (e.target.value.toString().indexOf(".") != -1) {
              no_int = false;
            } else {
              no_int = true;
            }
            if (wins_1.test(e.target.value) || lengths || points || remainder) {
              if (!no_int) {
                e.target.value = e.target.value
                  .replace(wins_1, "")
                  .replace(".", "$#$")
                  .replace(/\./g, "")
                  .replace("$#$", ".")
                  .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3")
                  .substring(0, e.target.value.indexOf(".") + 3);
              } else {
                e.target.value = e.target.value.replace(wins_0, "");
              }
              e.target.dispatchEvent(new Event("input"));
            }
          }
        }
      }, 0);
    });
  }
});
Vue.component("my-link", {
  render: function(createElement) {
    return createElement("link", {
      attrs: {
        rel: "stylesheet",
        href: this.src
      }
    });
  },
  props: {
    href: {
      type: String,
      required: true
    }
  }
});
Vue.component("my-script", {
  render: function(createElement) {
    return createElement("script", {
      attrs: {
        type: "text/javascript",
        src: this.src
      }
    });
  },
  props: {
    src: {
      type: String,
      required: true
    }
  }
});
function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}
function getState(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
}
let byCodeFlag = true;
let byCodeOpenFlag = true;
router.beforeEach((to, from, next) => {
  if (from.meta.keepAlive) {
    const $wrapper = document.querySelector(".wrapList");
    const scrollTop = $wrapper ? $wrapper.scrollTop : 0;
    from.meta.scrollTop = scrollTop;
  }

  to.meta.title && (document.title = to.meta.title);
  // localStorage.setItem("token", JSON.stringify({ 'etmss': 'A1yKm5KuRuaNpb/5clRZnw==', 'etmsl': '1_13410271814_1654128000' }));
  let token = localStorage.getItem("token");
  let company = 0;
  if (to.query && to.query.company) {
    company = to.query.company;
  }
  var tn = "";
  if (to.query && to.query.tn) {
    tn = to.query.tn;
  }
  if (to.name == "login") {
    let tenantNo = to.params.tenantNo;
    //页面是否登录
    if (token) {
      //本地存储中是否有token数据
      if (tenantNo && tenantNo != "000") {
        router.replace({ name: "loginTool", params: { tenantNo: tenantNo } });
      } else {
        router.replace({ path: "/homePage" });
      }
    } else {
      if (tenantNo) {
        if (getQueryVariable("code") && getState("state") != 2) {
          if (byCodeFlag) {
            apiPost("/parent/parentLoginByCode", {
              code: getQueryVariable("code"),
              tenantNo,
              company
            }).then(res => {
              byCodeFlag = false;
              if (res.data.resultData.type == 0) {
                let studentWechartId = res.data.resultData.studentWechartId;
                to.params.id = studentWechartId;
                next();
              } else if (res.data.resultData.type == 1) {
                localStorage.setItem(
                  "token",
                  JSON.stringify({
                    etmss: res.data.resultData.loginInfo.s,
                    etmsl: res.data.resultData.loginInfo.l
                  })
                );
                router.replace({ path: "/homePage" });
              }
            });
          }
        } else {
          // next();
          apiPost("/parent/parentGetAuthorizeUrl", {
            sourceUrl: `${etmsConfig.ErmsUrl}/#/login/${tenantNo}?company=${company}&tn=${tn}`,
            tenantNo,
            company
          }).then(res => {
            location.href = res.data.resultData;
          });
        }
      } else {
        router.replace({ path: "/loginOut" });
      }
    }
  } else if (to.name == "loginFast" || to.name == "loginSimple") {
    if (token) {
      router.replace({ path: "/homePage" });
    } else {
      next();
    }
  } else if (to.name == "loginUnion") {
    if (token) {
      router.replace({ path: "/homePage" });
    } else {
      next();
    }
  } else if (to.name == "register") {
    if (token) {
      router.replace({ path: "/homePage" });
    } else {
      next();
    }
  } else if (to.name == "registerOem") {
    if (token) {
      router.replace({ path: "/homePage" });
    } else {
      next();
    }
  } else if (to.name == "classRecordDetail") {
    wxUtils.init(to.query.tenantNo);
  } else if (to.name == "achievementDetail") {
    wxUtils.init(to.query.tenantNo);
  } else if (to.name == "archivesDetails") {
    wxUtils.init(to.query.tenantNo);
  } else if (to.name == "archivesDetails2") {
    wxUtils.init(to.query.tenantNo);
  } else if (to.name == "checkWork2") {
    wxUtils.init(to.query.tenantNo);
  } else if (to.name == "WxMessageDetail2") {
    wxUtils.init(to.query.tenantNo);
  } else if (to.name == "superformGate") {
    wxUtils.init(to.query.tenantNo);
  } else if (to.name == "loginOut") {
    next();
  } else if (to.name == "test") {
    next();
  } else if (to.name == "download") {
    next();
  } else if (to.name == "unbindStudent") {
    next();
  } else if (to.path.indexOf("michome") != -1) {
    wxUtils.init(to.query.tenantNo);
  } else if (to.name == "mallhome") {
    wxUtils.init(to.query.tenantNo);
  } else if (to.name == "mallhomeList") {
    wxUtils.init(to.query.tenantNo);
  } else if (to.name == "malldetail") {
    wxUtils.init(to.query.tenantNo);
  } else if (to.name == "albumDetail") {
    wxUtils.init(to.query.tenantNo);
  } else if (to.name == "galleryHome") {
    wxUtils.init(to.query.tenantNo);
  } else if (to.name == "autographAlbum") {
    wxUtils.init(to.query.tenantNo);
  } else if (to.name == "galleryImage") {
    wxUtils.init(to.query.tenantNo);
  } else if (to.name == "commentRecordDetail") {
    wxUtils.init(to.query.tenantNo);
  } else if (to.name == "wxMsg") {
    next();
  } else if (to.name == "visitorLogin") {
    next();
  } else if (to.name == "tryApplyPay") {
    let tenantNo = to.query.tenantNo;
    let stuNo = to.query.stuNo;
    if (!stuNo) {
      stuNo = "";
    }
    if (getQueryVariable("code") && getState("state") == 2) {
      if (byCodeOpenFlag) {
        apiPost("/open2/getWxOpenId", {
          code: getQueryVariable("code"),
          tenantNo
        }).then(res => {
          byCodeOpenFlag = false;
          let openId = res.data.resultData.openId;
          if (openId) {
            setLocal(`${tenantNo + "_" + "openId"}`, openId, 60);
          }
          next();
        });
      }
    } else {
      apiPost("/open2/getAuthorizeUrl", {
        tenantNo,
        state: "2",
        sourceUrl: `${etmsConfig.ErmsUrl}/#/tryApplyPay/?tenantNo=${tenantNo}&stuNo=${stuNo}`
      }).then(res => {
        location.href = res.data.resultData;
      });
    }
  } else if (to.name == "sureOrder") {
    let tenantNo = to.query.tenantNo;
    let cid = to.query.cid;
    if (token) {
      if (getQueryVariable("code") && getState("state") == 2) {
        if (byCodeOpenFlag) {
          apiPost("/open2/getWxOpenId", {
            code: getQueryVariable("code"),
            tenantNo
          }).then(res => {
            byCodeOpenFlag = false;
            let openId = res.data.resultData.openId;
            if (openId) {
              setLocal(`${tenantNo + "_" + "openId"}`, openId, 60);
            }
            next();
          });
        }
      } else {
        apiPost("/open2/getAuthorizeUrl", {
          tenantNo,
          state: "2",
          sourceUrl: `${etmsConfig.ErmsUrl}/#/sureOrder/?tenantNo=${tenantNo}&cid=${cid}`
        }).then(res => {
          location.href = res.data.resultData;
        });
      }
    } else {
      router.push({ name: "visitorLogin", query: { tenantNo, cid } });
    }
  } else if (to.name == "studentList") {
    let flag = localStorage.getItem("jzBindWechatFlag");
    if (flag) {
      if (getQueryVariable("code")) {
        apiPost("/parent/parentBindingWeChat", {
          code: getQueryVariable("code")
        }).then(res => {});
        localStorage.removeItem("jzBindWechatFlag");
      }
    }
  } else if (to.name == "loginAssistant") {
    let flag = localStorage.getItem("jzBindWechatFlag");
    if (flag) {
      if (getQueryVariable("code")) {
        apiPost("/parent/parentBindingWeChat", {
          code: getQueryVariable("code")
        }).then(res => {});
        localStorage.removeItem("jzBindWechatFlag");
      }
    }
    router.replace({ path: "/homePage" });
  } else if (to.name == "homePage") {
    try {
      let flag = localStorage.getItem("isHomeWeChart");
      if (flag) {
        if (getQueryVariable("code")) {
          apiPost("/parent/parentBindingWeChat", {
            code: getQueryVariable("code")
          }).then(res => {});
          localStorage.removeItem("isHomeWeChart");
        }
      }
    } catch (e) {
      console.log(e);
    }
  } else if (to.name == "galleryImage" || to.name == "galleryImageDetail") {
    wxUtils.init(to.query.tenantNo);
  } else if (to.name == "poster") {
    next();
  } else {
    let tenantNo = localStorage.getItem("tenantNo");
    if (token) {
      next();
    } else {
      if (tenantNo) {
        if (getQueryVariable("code") && getState("state") != 2) {
          if (byCodeFlag) {
            apiPost("/parent/parentLoginByCode", {
              code: getQueryVariable("code"),
              tenantNo
            }).then(res => {
              byCodeFlag = false;
              if (res.data.resultData.type == 0) {
                let studentWechartId = res.data.resultData.studentWechartId;
                router.replace({
                  path: "/login",
                  name: "login",
                  params: { id: studentWechartId }
                });
              } else if (res.data.resultData.type == 1) {
                localStorage.setItem(
                  "token",
                  JSON.stringify({
                    etmss: res.data.resultData.loginInfo.s,
                    etmsl: res.data.resultData.loginInfo.l
                  })
                );
                next();
              }
            });
          }
        } else {
          apiPost("/parent/parentGetAuthorizeUrl", {
            sourceUrl: `${etmsConfig.ErmsUrl}/#/login/${tenantNo}`,
            tenantNo,
            company
          }).then(res => {
            location.href = res.data.resultData;
          });
        }
      } else {
        router.replace({ path: "/loginOut" });
      }
    }
  }
  next();
});

//注册
Vue.prototype.$EventBus = new Vue();

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js